import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FavoritesProvider } from './context/FavoritesContext';
import { WatchHistoryProvider } from './context/WatchHistoryContext';

ReactDOM.render(
  <React.StrictMode>
    <FavoritesProvider>
      <WatchHistoryProvider>
        <App />
      </WatchHistoryProvider>
    </FavoritesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
